
export const getCompanyId = (company = '') => {
    return company.split('company_').join('') * 1;
}

export const CONTRACT_USER_ROLE = 6;

export const getCompanyFacilityIds = (allFacilities = [], company) => {
    const companyValue = company?.value ?? company;
    const companyId = typeof companyValue === 'string'
        ? companyValue.replace(/^company_/, '')
        : companyValue;

    return allFacilities
        .filter((facility) => String(facility?.record?.company_id) === String(companyId))
        .map((facility) => facility?.record?.id)
        .filter((facilityId) => facilityId !== null && facilityId !== undefined);
}

const mergeCompanyId = (companyId) => {
    return 'company_' + companyId;
}

// 将所有facility转换为树结构

export function convertToTreeStructure(allFancility, user) {
    const tree = {};

    allFancility.forEach(facility => {
        const { company, company_id, id, name } = facility.record;
        if(Array.isArray(user) && !user.includes(id)) {
            return;
        }

        const companyId = mergeCompanyId(company_id);

        if (!tree[companyId]) {
            tree[companyId] = {
                label: company,
                value: companyId,
                children: []
            };
        }

        // 添加子节点
        tree[companyId].children.push({
            label: name,
            value: id
        });
    });

    // 将对象转换为数组
    return Object.values(tree);
}


